import { post, put } from './axios'

//////////////////////////////////////////////////////////////////////
// POST
//////////////////////////////////////////////////////////////////////

/**
 * requestMoveOut
 */

export type RequestMoveOutParams = {
  userId: number
  moveOutOn: string
  phoneNumber: string
  message: string | null
  name: string | null
  postalCode: string | null
  address: string | null
  apartmentName: string | null
  roomNumber: string | null
}

export const requestMoveOut = async ({ userId, ...body }: RequestMoveOutParams) => {
  return await post(`/v1/users/${userId}/moveOutRequest`, body)
}

/**
 * sendInquiry
 */

export const InquiryType = {
  Others: 0, // その他
  // PaymentMethodRequest: 1, // 支払方法変更 // 使わない
  BillingAmount: 2, // 電気料金
  MoveIn: 3, // 入居
  MoveOut: 4, // 退去
  Reissue: 5, // 再発行
  ChangeBasicCapacity: 6, // 基本容量変更
  ChangeAddress: 7, // 送付先住所・電話番号変更
} as const
export type InquiryType = (typeof InquiryType)[keyof typeof InquiryType]

export type SendInquiryParams = {
  userId: number
  type: InquiryType
  phoneNumber: string
  message: string
}

export const sendInquiry = async ({ userId, ...body }: SendInquiryParams) => {
  return await post(`/v1/users/${userId}/inquiry`, body)
}

/**
 * sendInquiry
 */

export type UpdatePayerInfoParams = {
  userId: number

  payerFirstName?: string | null
  payerLastName?: string | null
  payerFirstNameKana?: string | null
  payerLastNameKana?: string | null
}

export const updatePayerInfo = async ({ userId, ...body }: UpdatePayerInfoParams) => {
  return await put(`/v1/users/${userId}/payerInfo`, body)
}
